import { useCallback, useEffect, useState } from "react";
import api from "../../util/axios";

type Props = {
    url: string;
    params?: Record<string, string | number | boolean>;
};

export const usePost = <T, BodyDataType>(props:Props) : [
    (data: BodyDataType) => Promise<T | null>,
    {
        value?: T;
        loading: boolean;
        called: boolean;
        error?: string;
        isSuccess: boolean;
    }
] => {

    const { url } = props;
    const [value, setValue] = useState<T>();
    const [error, setError] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);
    const [called, setCalled] = useState<boolean>(false);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);


    const postCall = useCallback(
        async (data: BodyDataType): Promise<T | null> => {
            setCalled(true);
            setLoading(true);
            setError("");
            setIsSuccess(false);

            const request = async(
                params?: Record<string, string | number | boolean>
            ) => {
                
                setLoading(true);
                setValue(undefined);
                setError(undefined);
        
                await api
                    .post(url, data)
                    .then( res => {
                        setValue(res.data)
                        return res.data;
                    })
                    .catch( e  => setError(e) )
                    .finally(() => setLoading(false) )

                return null;
            }
            const result = await request();
            return result;
        }, [url]
    );


    return [
        postCall, 
        {
            value,
            loading,
            called,
            error,
            isSuccess
        }
    ];
}